import { jsx, jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { breakpoints } from "@crehana/ui";
import * as __rspack_external__sentry_browser_2219f812 from "@sentry/browser";
import { ErrorBoundary } from "react-error-boundary";
import styled_components from "styled-components";
const Cat = styled_components.div`
  background-position: center;
  background-size: cover;
  width: 131px;
  height: 190px;
  ${breakpoints.up('sm')} {
    width: 250px;
    height: 350px;
  }
  background-image: url('https://static.crehana.com/static/img/crehana-cat-in-jar.png');
`;
const Container = styled_components.div`
  max-width: 600px;
  ${breakpoints.up('md')} {
    max-width: 700px;
  }
`;
const CatErrorPage = ({ sentryEventId, sentryInstance: sentryInstanceProp })=>{
    const sentryInstance = sentryInstanceProp || __rspack_external__sentry_browser_2219f812;
    return /*#__PURE__*/ jsx("div", {
        className: "flex items-center justify-center w-full h-screen p-12 bg-white",
        children: /*#__PURE__*/ jsxs(Container, {
            className: "flex flex-col w-full h-full md:flex-row sm:h-auto",
            children: [
                /*#__PURE__*/ jsx(Cat, {
                    className: "flex-shrink-0"
                }),
                /*#__PURE__*/ jsxs("div", {
                    className: "mt-12 tw-font-pop md:mt-0",
                    style: {
                        lineHeight: '1.5'
                    },
                    children: [
                        /*#__PURE__*/ jsx("h2", {
                            style: {
                                fontSize: 24
                            },
                            children: "Oops, tenemos un problema..."
                        }),
                        /*#__PURE__*/ jsx("br", {}),
                        /*#__PURE__*/ jsx("p", {
                            className: "mt-4 text-16",
                            children: "Nuestro equipo acaba de ser informado y est\xe1 trabajando para solucionarlo. Si quieres ayudar, cu\xe9ntanos qu\xe9 ha pasado a continuaci\xf3n."
                        }),
                        /*#__PURE__*/ jsx("br", {}),
                        /*#__PURE__*/ jsx("button", {
                            type: "button",
                            className: "inline-flex items-center justify-center w-full h-auto px-40 py-8 tw-font-semibold text-white cursor-pointer focus:outline-none md:h-48 md:py-0 bg-purple-main hover:bg-secondary-main sm:w-auto",
                            onClick: ()=>{
                                sentryInstance.showReportDialog({
                                    eventId: sentryEventId,
                                    title: 'Oops, tenemos un problema...',
                                    subtitle2: 'Si quieres ayudar, cuéntanos qué ha pasado a continuación.'
                                });
                            },
                            children: "Brindar detalles del error"
                        }),
                        /*#__PURE__*/ jsx("br", {}),
                        /*#__PURE__*/ jsx("button", {
                            onClick: ()=>window.location.reload(),
                            className: "p-8 mt-12 text-secondary-main",
                            type: "button",
                            children: "O puedes intentar recargando la p\xe1gina."
                        })
                    ]
                })
            ]
        })
    });
};
const RootErrorBoundaryWithSentry = ({ children, sentryInstance: sentryInstanceProp })=>{
    const sentryInstance = sentryInstanceProp || __rspack_external__sentry_browser_2219f812;
    const [sentryEventId, setSentryEventId] = useState(void 0);
    return /*#__PURE__*/ jsx(ErrorBoundary, {
        FallbackComponent: ()=>/*#__PURE__*/ jsx(CatErrorPage, {
                sentryEventId: sentryEventId,
                sentryInstance: sentryInstance
            }),
        onError: (error, info)=>{
            sentryInstance.withScope((scope)=>{
                scope.setTag('error_type', 'critical');
                scope.setTag('error_origin', 'root_error_boundary');
                scope.setExtras(info);
                const eventId = sentryInstance.captureException(error);
                setSentryEventId(eventId);
            });
        },
        children: children
    });
};
const ErrorBoundaries_RootErrorBoundaryWithSentry = RootErrorBoundaryWithSentry;
export default ErrorBoundaries_RootErrorBoundaryWithSentry;
export { RootErrorBoundaryWithSentry };
